import React, { useEffect, useRef  } from 'react';
import { useLocation, Link, useNavigate } from 'react-router-dom';
import { ThankYou , StarIcon ,BtnArrow } from "../../svgIcon";
import { Container, Row, Col} from "react-bootstrap";
import "./_thank-you.scss";
const ThankYouPage = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const sectionRef = useRef(null);

    useEffect(() => {
        if (!location.state?.fromSubmission) {
            navigate("/");
        } else {
            window.history.replaceState({}, document.title);
            if (sectionRef.current) {
                sectionRef.current.scrollIntoView({ behavior: 'smooth' });
            }
        }
    }, [location, navigate]);

    const message = location.state?.message || "Your message has been successfully sent!";
    return (
        <section ref={sectionRef} className="thank-you page-not-found inner-page-gap double-gap">
            <span className="star-pattern">
                <i className="star first"><StarIcon /></i>
                <i className="star second"><StarIcon /></i>
                <i className="star third"><StarIcon /></i>
            </span>
            <Container>
                <Row className="justify-content-center">
                    <Col lg={10}>
                        <div className="ty-contbox text-center">
                            <div className="ty-icon mb-4"><ThankYou /></div>
                            <h2 className="sec-heading text-center mb-4" data-aos="fade">
                                <span className="ff-2">
                                    <span className="star">
                                        <i className="blue" data-aos="zoom-in" data-aos-duration="1500" data-aos-delay="100"><StarIcon/></i>
                                        <i className="red" data-aos="zoom-in" data-aos-duration="1500" data-aos-delay="300"><StarIcon/></i>
                                        <i className="yellow" data-aos="zoom-in" data-aos-duration="1500" data-aos-delay="100"><StarIcon/></i>
                                    </span>
                                    <span data-aos="fade" data-aos-duration="1500" data-aos-delay="500">It’s Time To Execute</span>
                                </span>
                                <span className="title-line" data-aos="fade" data-aos-duration="1500" data-aos-delay="500">
                                <span>Thank you</span>
                                </span>
                            </h2>
                            <div className="content">
                                <p>{message}</p>
                            </div>
                            <Link to="/" className="btn btn-primary mt-5">
                                Back to Home
                                <svg xmlns="http://www.w3.org/2000/svg" width="17.253" height="13.4" viewBox="0 0 17.253 13.4">
                                    <path id="Path_73" data-name="Path 73" d="M1191.633,1924.5h15.327a1.036,1.036,0,0,0,.676-.288.937.937,0,0,0,0-1.351,1.036,1.036,0,0,0-.676-.288h-15.327a1.036,1.036,0,0,0-.676.288.938.938,0,0,0,0,1.351A1.036,1.036,0,0,0,1191.633,1924.5Zm8.9,4.112a.945.945,0,0,0-.273.676.9.9,0,0,0,.288.661.96.96,0,0,0,.676.288,1,1,0,0,0,.661-.273l5.751-5.751a.937.937,0,0,0,0-1.351l-5.751-5.751a1,1,0,0,0-.661-.273.959.959,0,0,0-.676.288.9.9,0,0,0-.288.661.945.945,0,0,0,.273.676l5.075,5.075Z" transform="translate(-1190.67 -1916.84)" fill=""></path>
                                </svg>
                            </Link>
                        </div>
                    </Col>
                </Row>
            </Container>
        </section>
    );
};

export default ThankYouPage;